import React from "react";
import styled from "styled-components";
const ServiceContainer = styled.div`
  width: 32%;
  height: 300px;
  margin: 0 1% 1% 0;
  border: 1px solid #eee;
  border-radius: 5px;
  @media (max-width: 768px) {
    height: 220px;
    width: 46%;
  }
  background: white;
  cursor: pointer;
  overflow: hidden;
`;
const ImageContainer = styled.div`
  width: 100%;
  height: 65%;
  background: white;
  text-align: center;
  @media (max-width: 768px) {
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
`;

const DetailsContainer = styled.div`
  width: 80%;
  height: 30%;
  padding: 0 5%;
  @media (max-width: 768px) {
  }
`;
const Details = styled.div`
  width: 80%;
  height: 100%;
  float: left;
  @media (max-width: 768px) {
    width: 70%;
  }
`;
const ProductName = styled.h2`
  font-size: 1.1em;
  margin: 0;
  padding: 4% 0;
  font-weight: 400;
`;
const Measurement = styled.p`
  font-size: 1em;
  margin: 0;
  padding: 2% 0 2.7% 0;
`;
const Price = styled.button`
  font-size: 1em;
  margin: 0;
  padding: 0;
  padding: 8px 20px;
  color: white;
  background: #e25f17;
  border: none;
  border-radius: 5px;
  outline: none;
`;
const AddButton = styled.button`
  float: right;
  font-size: 20px;
  margin: 10% 10px 0 0;
  background: white;
  border: 1px solid #ccc;
  padding: 5px 12px;
  color: #ccc;
  cursor: pointer;
  outline: none;
  border-radius: 5px;
  &:hover {
    color: black;
    border: 1px solid black;
  }
`;
function Service(props) {
  return (
    <ServiceContainer
      onClick={() => props.showProductHandler(props.product._id)}
    >
      <ImageContainer>
        <Image src={props.product.product.images[0]} alt="product name" />
      </ImageContainer>
      <DetailsContainer>
        {/* <Details> */}
        <ProductName>{props.product.name}</ProductName>
        {/* <Measurement>{props.product.product.measurment}</Measurement> */}
        <Price>{props.product.price} tk</Price>
        {/* </Details> */}
        {/* <AddButton
          onClick={() => {
            props.addToCartHandler(props.id);
          }}
        >
          +
        </AddButton> */}
      </DetailsContainer>
    </ServiceContainer>
  );
}

export default Service;
